/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CategoryDto, CategoryRequestDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class CategoryService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags CategoryService
   * @name GetCategory
   * @summary Get Category by ID
   * @request GET:/v1/categories/{categoryId}
   * @secure
   */
  getCategory = (categoryId: number, params: RequestParams = {}) =>
    this.http.request<CategoryDto, any>({
      path: `/v1/categories/${categoryId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CategoryService
   * @name UpdateCategory
   * @summary Update Category
   * @request PUT:/v1/categories/{categoryId}
   * @secure
   */
  updateCategory = (categoryId: number, data: CategoryRequestDto, params: RequestParams = {}) =>
    this.http.request<CategoryDto, any>({
      path: `/v1/categories/${categoryId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CategoryService
   * @name DeleteCategory
   * @summary Delete Category
   * @request DELETE:/v1/categories/{categoryId}
   * @secure
   */
  deleteCategory = (categoryId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/categories/${categoryId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags CategoryService
   * @name GetCategories
   * @summary Get Categories
   * @request GET:/v1/categories
   * @secure
   */
  getCategories = (
    query?: {
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CategoryDto[], any>({
      path: `/v1/categories`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CategoryService
   * @name CreateCategory
   * @summary Create Category
   * @request POST:/v1/categories
   * @secure
   */
  createCategory = (data: CategoryRequestDto, params: RequestParams = {}) =>
    this.http.request<CategoryDto, any>({
      path: `/v1/categories`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
